import React from 'react';
import { useEntitlement } from '../../hooks/useEntitlement';
import { PAYPAL_ME_URL, PRO_PRICE_LABEL } from '../../config/billing';

/**
 * Slim banner shown to trialing users in the final stretch (≤3 days left),
 * paywall bridge. Nudges the PayPal pay-path before access lapses. Renders
 * nothing otherwise. Styled by `.trial-banner` (trader theme).
 */
const TrialBanner: React.FC = () => {
  const { isTrialing, trialDaysLeft } = useEntitlement();
  if (!isTrialing || trialDaysLeft == null || trialDaysLeft > 3) return null;

  const days = `${trialDaysLeft} day${trialDaysLeft === 1 ? '' : 's'}`;

  return (
    <div role="status" className="trial-banner">
      <span>
        Your Pro trial ends in <strong>{days}</strong>. Keep Real-Yield, roll-vs-assign and unlimited AI.
      </span>
      <a href={PAYPAL_ME_URL} target="_blank" rel="noopener noreferrer">
        Keep Pro · {PRO_PRICE_LABEL}
      </a>
    </div>
  );
};

export default TrialBanner;
